import { FloatingLabel, Form } from "react-bootstrap";

function MyInput({
  label,
  type = "text",
  value,
  onChange,
  required = false,
  error,
  as,
  options,
  disabled,
  name,
  dontShowDay = false,
  formData,
  percent,
}) {
  const today = new Date().toISOString().split("T")[0];
  const inputValue =
    type === "date" ? (dontShowDay ? value || "" : value || today) : value;

  return (
    <div className="my-input-container mb-3">
      <FloatingLabel label={label}>
        {as === "select" ? (
          <Form.Select
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            name={name}>
            {options.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <>
            <Form.Control
              type={type}
              placeholder={label}
              value={inputValue}
              onChange={onChange}
              className="mySA"
              required={required}
              name={name}
              disabled={disabled}
            />
            {percent &&
            <span
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#424040ff",
                fontSize: "20px"
              }}>
              %
            </span>}
          </>
        )}
      </FloatingLabel>
      {error && (
        <div className="text-danger mt-1" style={{ direction: "rtl" }}>
          {error}
        </div>
      )}
    </div>
  );
}

export default MyInput;
